import React from 'react'
import { Divider, List, Tag, Typography } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons'
import ReferenceReasonings from '../../../pages/assignment/components/file-drawer/file-criteria-reasoning/ReferenceReasonings'

const CriteriaList = ({ 
    criteria, 
    token, 
    layerId, 
    patternId, 
    onOpenFile,
    getReferenceReasoningsForCriterion
}) => {
    if (!criteria || criteria.length === 0) return null

    return (
        <>
            {criteria.map((criterion, index) => {
                // Get reference reasonings for this criterion
                const references = getReferenceReasoningsForCriterion(criterion.id, index)

                const metIcon = criterion.isMet ? (
                    <CheckCircleOutlined style={{ color: 'green' }} />
                ) : (
                    <CloseCircleOutlined style={{ color: 'red' }} />
                )

                return (
                    <div key={criterion.id || index}>
                        <List itemLayout="vertical">
                            <List.Item>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    {metIcon}
                                    <Typography.Text strong>{criterion.value}</Typography.Text>
                                </div>
                                <div style={{ marginLeft: '22px' }}>
                                    <div>
                                        {criterion.hasOverrule && <EditOutlined title='Overruled' style={{ marginRight: '5px' }} />}
                                        <Typography.Text type="secondary">{criterion.reasoning}</Typography.Text>
                                    </div>
                                    
                                    {criterion.tags && criterion.tags.length > 0 && (
                                        <div style={{ marginTop: '8px' }}>
                                            {criterion.tags.map(tag => (
                                                <Tag key={tag} color="blue" style={{ marginRight: '4px' }}>
                                                    {tag}
                                                </Tag>
                                            ))}
                                        </div>
                                    )}
                                    
                                    {/* Reference Reasonings component */}
                                    {references && references.length > 0 && (
                                        <ReferenceReasonings
                                            references={references}
                                            token={token}
                                            layerId={layerId}
                                            patternId={patternId}
                                            criterion={{
                                                id: criterion.id,
                                                criterion: criterion.criterion,
                                                reasoning: criterion.reasoning,
                                                met: criterion.met,
                                                key: index
                                            }}
                                            onOpenFile={onOpenFile}
                                        />
                                    )}
                                </div>
                            </List.Item>
                        </List>
                        {index < criteria.length - 1 && <Divider style={{ margin: '12px 0' }} />}
                    </div>
                )
            })}
        </>
    )
}

export default CriteriaList
